// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"style__wrapper__AyZCV","reportBodyText":"style__reportBodyText__18BB0"};